import { render, staticRenderFns } from "./TotalsModule.vue?vue&type=template&id=764f4c1d"
import script from "./TotalsModule.vue?vue&type=script&lang=js"
export * from "./TotalsModule.vue?vue&type=script&lang=js"
import style0 from "./TotalsModule.vue?vue&type=style&index=0&id=764f4c1d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports